<template>
    <div>
        <p>
            <a @click="handleJumpTo('privacyPolicy')">Privacy Policy |</a>
            <a @click="handleJumpTo('termsService')">Terms of Service </a>
            <a></a>
        </p>
        <p> Copyright © 2019 - {{ year }} X-Poker. All Rights Reserved.</p>
    </div>
</template>

<script>
export default {
  name: 'defaultFooter',
  data () {
    return {
      year: new Date().getFullYear()
    }
  },
  methods: {
    handleJumpTo (name) {
      const { href } = this.$router.resolve({
        name: name
      })
      window.open(href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/components/foot.vue